import React from 'react';
import { NavLink } from "react-router-dom";
import * as Icon from 'react-feather';
import _ from 'lodash';
import { NotificationManager } from '../../helpers/NotificationManager';
import { Screen } from '../App/Screen';
import { ClassificationTypesList } from './List';
import { EntityService } from '../../services/EntityService';

export class ClassificationTypesListContainer extends React.Component {
    constructor(props) {
        super(props);

        // Setup the default state
        this.state = {
            classificationTypes: [],
            isClassificationTypesLoaded: false,
            isSearchingActive: false
        };

        // Bind the finctions that will be passed to the other components.
        // Doing this means that the function will be executed within the context of this container.
        this.handleSearch = this.handleSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        // Define and initialise the the relevant properties and services etc.
        this.EntityService = new EntityService("ClassificationTypes");
    }

    componentDidMount() {
        // Retrieve the ClassificationTypes.
        // Once these have been obtained, we will add these items into the state
        // When they are in the state they can then be used within other components.
        this.handleSearch();
    }

    handleSearch(searchText) {
        this.setState({ 
            isSearchingActive: true
        });

        const handleResponse = (response) => {
            const classificationTypes = response.data.results.map(classificationType => {
                return {
                    ...classificationType
                };
            });

            this.setState({ 
                classificationTypes: classificationTypes,
                isClassificationTypesLoaded: true,
                isSearchingActive: false
            });
        };

        const handleError = (error) => {
            NotificationManager.error('Could not obtain results for Classification Types', 'Error', 1000);
        };

        if(searchText && searchText.length > 0) {
            this.EntityService.search(searchText, 1, 1000, 'Name', 'asc').then(handleResponse, handleError);
        }
        else {
            this.EntityService.getList(1, 1000, 'Name', 'asc').then(handleResponse, handleError);
        }
    }

    handleEdit(classificationType, e) {
        e.preventDefault();
        this.props.history.push('/classification-types/edit/' + classificationType.id);
    }

    handleDelete(classificationType, e) {
        e.preventDefault();

        this.EntityService.delete(classificationType.id).then(
            response => { 
                const classificationTypes = _.filter(this.state.classificationTypes, x => x.id !== classificationType.id);
                this.setState({ classificationTypes: classificationTypes }, () => {
                    NotificationManager.success('The classification type ' + classificationType.name + ' was deleted.', 'Classification Type Deleted', 1000);
                });
            },
            error => {
                NotificationManager.error('Classification Type was not deleted', 'Error', 1000);
            }
        );
    }

    render() {
        const isLoaded = this.state.isClassificationTypesLoaded;

        // Buold the Screen menu.
        // This will be passed to the Screen component so that it can be rendered in the relevant place.
        const screenMenu = (
            <NavLink  to="/classification-types/create" className="btn btn-sm btn-success">
                <Icon.PlusCircle className="feather" />&nbsp;&nbsp;Create Classification Type
            </NavLink>
        );
        
        // Define the setting for the screen loader
        // This object will be passed to the Screen component,
        // Which will determine how and if the loader should be displayed
        const screenLoader = {
            isEnabled: true,
            isLoaded: isLoaded,
            text: "Loading Classification Types..."
        };

        return (
            <Screen title="Classification Types" menu={screenMenu} loader={screenLoader}>
                <ClassificationTypesList
                    items={this.state.classificationTypes}
                    handleSearch={this.handleSearch}
                    handleEdit={this.handleEdit}
                    handleDelete={this.handleDelete}
                />
            </Screen>
        );
    }
}
